export const getCheckout = state => state.checkout;
export const getCheckoutResponse = state => state.checkoutResponse;

export default {
  getCheckout,
  getCheckoutResponse
};
